import { render, staticRenderFns } from "./TailwindInput.vue?vue&type=template&id=2b3bc086&scoped=true&"
import script from "./TailwindInput.vue?vue&type=script&lang=ts&"
export * from "./TailwindInput.vue?vue&type=script&lang=ts&"
import style0 from "./TailwindInput.vue?vue&type=style&index=0&id=2b3bc086&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b3bc086",
  null
  
)

export default component.exports